/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountData } from './AccountData';
import {
    AccountDataFromJSON,
    AccountDataFromJSONTyped,
    AccountDataToJSON,
    AccountDataToJSONTyped,
} from './AccountData';

/**
 * 
 * @export
 * @interface AccountCsvData
 */
export interface AccountCsvData {
    /**
     * 
     * @type {string}
     * @memberof AccountCsvData
     */
    lobKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCsvData
     */
    officeKey?: string | null;
    /**
     * 
     * @type {AccountData}
     * @memberof AccountCsvData
     */
    accountData: AccountData;
}

/**
 * Check if a given object implements the AccountCsvData interface.
 */
export function instanceOfAccountCsvData(value: object): value is AccountCsvData {
    if (!('accountData' in value) || value['accountData'] === undefined) return false;
    return true;
}

export function AccountCsvDataFromJSON(json: any): AccountCsvData {
    return AccountCsvDataFromJSONTyped(json, false);
}

export function AccountCsvDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCsvData {
    if (json == null) {
        return json;
    }
    return {
        
        'lobKey': json['lobKey'] == null ? undefined : json['lobKey'],
        'officeKey': json['officeKey'] == null ? undefined : json['officeKey'],
        'accountData': AccountDataFromJSON(json['accountData']),
    };
}

export function AccountCsvDataToJSON(json: any): AccountCsvData {
    return AccountCsvDataToJSONTyped(json, false);
}

export function AccountCsvDataToJSONTyped(value?: AccountCsvData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lobKey': value['lobKey'],
        'officeKey': value['officeKey'],
        'accountData': AccountDataToJSON(value['accountData']),
    };
}

